import { setObjects } from '../helpers'

const initialState = () => ({
    storage: { },
    terms: { },
    periods: { },
    assignments: { },
})

const mutations = {
    ADD_GROUPS (state, groups) {
        setObjects(groups, state.storage, { students: [], groupTerms: []})
    },

    SET_STUDENTS_FOR_GROUP (state, students, groupId) {
        state.storage[groupId].students = students
    },
    SET_GROUP_TERMS_FOR_GROUP (state, groupId, groupTerms) {
        state.storage[groupId].groupTerms = groupTerms.map( t => t.id )
    },

    ADD_GROUP_TERMS (state, groupTerms) {
        setObjects(groupTerms, state.terms, { groupPeriods: [] })
    },

    ADD_GROUP_PERIODS (state, groupPeriods) {
        setObjects(groupPeriods, state.periods, { assignments: [], groupAssignments: [] })
    },

    ADD_GROUP_ASSIGNMENTS (state, groupAssignments) {
        setObjects(groupAssignments, state.assignments)
    },


}

export default {
    initialState,
    state: initialState(),
    mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/groups.js